import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Badge,
  IconButton,
  Popover,
  List,
  Typography,
  Button,
  Divider,
  CircularProgress,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import NotificationItem from "./NotificationItem";
import MainCard from "./MainCard";
import {
  notificationAction,
  selectNotification,
} from "state/reducer/notification";
import { selectUser } from "state/reducer/user";
import { cookies } from "utils/cookies";

const NotificationList = ({ notification }) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const { notifications, loading } = useSelector((state) => state.notification);

  const profile = useSelector(selectUser).getProfile;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    // Fetch notifications when opening the popover
    dispatch({ type: "FETCH_NOTIFICATIONS_REQUEST" });
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMarkAsRead = (id) => {
    // dispatch({ type: "MARK_NOTIFICATION_READ", payload: id });
    dispatch(
      notificationAction.markNotificationAsReadThunk({
        pathname: "/mark-as-read",
        body: {
          id,
          userId: profile?.data?._id,
        },
        accessToken:
          cookies?.get("token")?.token ||
          cookies.get("refreshToken")?.refreshToken,
      })
    );
  };

  const handleMarkAllAsRead = () => {
    // dispatch({ type: "MARK_ALL_NOTIFICATIONS_READ" });
    dispatch(
      notificationAction.markNotificationAsReadThunk({
        pathname: "/mark-as-read",
        body: {
          // id,
          // userId: profile?.data?._id,
        },
        accessToken:
          cookies?.get("token")?.token ||
          cookies.get("refreshToken")?.refreshToken,
      })
    );
  };

  const open = Boolean(anchorEl);
  const id = open ? "notification-popover" : undefined;

  return (
    <>
      <IconButton
        color="inherit"
        aria-describedby={id}
        onClick={handleClick}
        size="large"
      >
        <Badge
          badgeContent={notification?.data?.data.unreadCount}
          color="error"
        >
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            width: 350,
            maxHeight: 450,
            overflow: "hidden",
          },
        }}
      >
        <Box
          sx={{
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6">Notifikasi</Typography>
          {notification?.data?.data.unreadCount > 0 && (
            <Button size="small" onClick={handleMarkAllAsRead}>
              Tandai semua dibaca
            </Button>
          )}
        </Box>
        <Divider />
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
            <CircularProgress size={24} />
          </Box>
        ) : (
          <>
            {notification?.data?.data.notifications.length > 0 ? (
              <List sx={{ maxHeight: 350, overflow: "auto" }}>
                {notification?.data?.data.notifications?.map((notification) => (
                  <NotificationItem
                    key={notification.id}
                    notification={notification}
                    onMarkAsRead={handleMarkAsRead}
                  />
                ))}
              </List>
            ) : (
              <Box sx={{ p: 3, textAlign: "center" }}>
                <Typography variant="body2" color="textSecondary">
                  Tidak ada notifikasi
                </Typography>
              </Box>
            )}
          </>
        )}
        <Divider />
        <Box sx={{ p: 1, display: "flex", justifyContent: "center" }}>
          <Button
            size="small"
            onClick={() => {
              /* Navigate to all notifications */
            }}
          >
            Lihat semua notifikasi
          </Button>
        </Box>
      </Popover>
    </>
  );
};

export default NotificationList;
